export class SelectorItem {
    key: string;
    value: string;
    group: string;
    items: Array<SelectorItem>;

    // Helpers
    isOver: boolean;

    constructor(key: string, value: string | any, items: Array<SelectorItem>) {
      this.key = key;
      this.value = value;
      this.items = items;
    }
  }
